function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Context } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import { Dialogs } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { RemoveItems } from '@leverege/molten/imagine';
import { Names, Types } from "../constants/index.js";
import AbstractFotaItemDelegate from "../delegates/AbstractFotaItemDelegate.js";
const {
  tIcon
} = I18N.ns('api-ui-fota-management.DeleteAction');
export default {
  id: 'blueprint.action.fota.DeleteItem',
  name: 'Delete Fota Items',
  layout: {
    sort: 'item.delete'
  },
  matches: [{
    // client : [ null, 'GroupScreen' ],
    use: ['contextMenu', 'mobileActionBar'],
    objectType: Types.updateable
  }, {
    client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
    use: ['contextMenu', 'mobileActionBar'],
    objectType: Types.updateable
  }],
  isPrepared: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const targets = Context.getTargetsOfType(cxt, objectType);
    if (targets == null || targets.length === 0) {
      // nothing to do
      return true;
    }
    return targets.every(tgt => {
      const delegate = DataSources.getDelegate(tgt);
      return delegate.canDelete() != null;
    });
  },
  prepare: async cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const targets = Context.getTargetsOfType(cxt, objectType);
    await Promise.all(targets.map(tgt => {
      const delegate = DataSources.getDelegate(tgt);
      return delegate.canDelete() == null ? GlobalState.dispatch(delegate.requestCanDelete()) : null;
    }));
    return null;
  },
  handles: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const targets = Context.getTargetsOfType(cxt, objectType);
    if (targets == null || targets.length === 0) {
      return false;
    }
    return targets.every(tgt => {
      const delegate = DataSources.getDelegate(tgt);
      return delegate?.canDelete() === true;
    });
  },
  appearance: ({
    context,
    action
  }) => {
    const {
      clientProps: {
        objectType
      }
    } = context;
    const targets = Context.getTargetsOfType(context, objectType);
    const num = targets.length;
    return {
      name: num < 2 ? `Delete ${Names[objectType]}` : `Delete ${num} ${Names[`${objectType}Plural`]}`,
      icon: tIcon('icon'),
      disabled: num === 0
    };
  },
  perform: ({
    context,
    action
  }) => {
    const {
      clientProps: {
        objectType,
        delegate,
        relationship: {
          blueprint
        }
      },
      reloadData
    } = context;
    const targets = Context.getTargetsOfType(context, objectType);
    if (targets.length === 0) {
      return;
    }
    Dialogs.show({
      component: props => {
        const {
          onClose
        } = props;
        const nOnClose = () => {
          onClose();
          console.log('uhhh');
          reloadData();
        };
        return /*#__PURE__*/React.createElement(RemoveItems, _extends({}, props, {
          onClose: nOnClose
        }));
      },
      props: {
        blueprint,
        targets,
        delegate,
        isItem: delegate instanceof AbstractFotaItemDelegate,
        deleteDevice: true
      }
    });
  }
};